<template>
  <div v-if="isVisible" class="cookies-window">
    <div class="content inner">
      <div class="content-section">
        <div class="cookies-window__inner">
          <div class="cookies-window__title" v-html="title" />
          <div v-if="text" class="cookies-window__text" v-html="text" />
          <div class="cookies-window__actions">
            <button
              class="cookies-window__btn button button_white"
              v-html="btnText"
              @click="cookiesAccept"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isVisible: false,
      cookiesStorageName: '_cookies-is-accept'
    }
  },

  created() {
    this.checkVisibleState()
  },

  methods: {
    setStateVisible(state) {
      this.isVisible = state
    },
    checkVisibleState() {
      if (!window.localStorage.getItem(this.cookiesStorageName)) {
        this.setStateVisible(true)
      }
    },
    cookiesAccept() {
      this.isVisible = false
      window.localStorage.setItem(this.cookiesStorageName, 'Y')
    }
  }
}
</script>
